import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AppProvider, useToast } from '@alpine-iq/ui-library'
import '@alpine-iq/ui-library/styles/main.css'
import { setToasterInstance } from './utils/toaster'
import { injectPortalStyles } from './utils/portal-styles'

injectPortalStyles()

console.log(
  `%c AIQ Widget %c ${process.env.AIQ_CHAT_WIDGET_VERSION} %c ${process.env.AIQ_ENV} `,
  'background: #6366f1; color: white; font-weight: bold; padding: 2px 4px; border-radius: 3px 0 0 3px;',
  'background: #1e1e2e; color: #a5b4fc; padding: 2px 4px;',
  'background: #10b981; color: white; padding: 2px 4px; border-radius: 0 3px 3px 0;'
)

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <div className="aiq-widget-scope">
      <AppProvider>
        <ToastWrapper>
          <App />
        </ToastWrapper>
      </AppProvider>
    </div>
  </React.StrictMode>
)

function ToastWrapper({ children }: { children: React.ReactNode }) {
  const toaster = useToast()

  useEffect(() => {
    if (toaster) setToasterInstance(toaster)
  }, [toaster])

  return children
}
